import { Injectable, inject, signal } from '@angular/core';
import { MTM_AUTH_CLIENT } from '@mtm/auth-ui-angular';

@Injectable({ providedIn: 'root' })
export class TenantContextService {
  private readonly auth = inject(MTM_AUTH_CLIENT);

  readonly tenantUuid = signal<string | null>(null);

  refresh(): void {
    this.tenantUuid.set(this.auth.getTenantUuid());
  }
}
